import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "lang-label" }
const _hoisted_3 = {
  key: 0,
  class: "lang-dropdown"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "lang-option-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "lang-selector",
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.openDropdown && $setup.openDropdown(...args))),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.closeDropdown && $setup.closeDropdown(...args)))
  }, [
    _createElementVNode("img", {
      src: $setup.currentLangIcon,
      width: "16",
      height: "16",
      class: "pointer lang-image"
    }, null, 8, _hoisted_1),
    _createElementVNode("label", _hoisted_2, _toDisplayString($props.currentLanguage.toUpperCase()), 1),
    ($setup.showDropdown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.languages, (lang) => {
            return (_openBlock(), _createElementBlock("div", {
              key: lang.code,
              class: _normalizeClass(["pointer lang-option", { 'lang-option-selected': lang.code === $props.currentLanguage }]),
              onClick: ($event: any) => ($setup.selectLanguage(lang.code)),
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleHover(true)))
            }, [
              _createElementVNode("img", {
                src: lang.icon,
                width: "16",
                height: "16",
                class: "lang-option-icon"
              }, null, 8, _hoisted_5),
              _createElementVNode("span", _hoisted_6, _toDisplayString(lang.code.toUpperCase()), 1)
            ], 42, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}